import { render, staticRenderFns } from "./ui_datatable.vue?vue&type=template&id=4b15ad1a&"
import script from "./ui_datatable.vue?vue&type=script&lang=js&"
export * from "./ui_datatable.vue?vue&type=script&lang=js&"
import style0 from "./ui_datatable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports